import { PropsWithChildren, useMemo } from 'react';
import { AmplifyServiceContext } from './AmplifyServiceContext';
import { initAuthClient } from './auth-client/factories/amplify-auth-client';
import { useAuthentificationReducer } from './useAuthentificationReducer';
export const AmplifyService = ({
  children
}: PropsWithChildren) => {
  const reducerState = useAuthentificationReducer();
  const value = useMemo(() => {
    const {
      state,
      ...rest
    } = reducerState;
    return {
      ...state,
      ...rest
    };
  }, [reducerState]);
  return <AmplifyServiceContext.Provider value={value} data-sentry-element="unknown" data-sentry-component="AmplifyService" data-sentry-source-file="AmplifyService.tsx">
      {children}
    </AmplifyServiceContext.Provider>;
};
AmplifyService.init = initAuthClient;